<form class="day-row" *ngIf="form" [formGroup]="form" [class.day-off]="isDayOff" [class.invalid]="form.invalid">
    <div class="day-label">
        <span class="day-name">{{ label }}</span>
        <span class="day-off-badge" *ngIf="isDayOff">{{ 'DayOff' | translate: {Default: "Day off"} }}</span>
        <span class="row-error" *ngIf="form.invalid">{{ 'StartAndEndTimeRequired' | translate: {Default: "Add both times"} }}</span>
    </div>

    <div class="cell">
        <span class="cell-label">{{ 'StartTime' | translate: {Default: "Start time"} }}</span>
        <mat-form-field appearance="fill" subscriptSizing="dynamic">
            <input
                matInput
                [attr.aria-label]="label + ' start time'"
                placeholder="--:--"
                [ngxTimepicker]="startTime"
                [format]="24"
                formControlName="startTime"
            />
            <mat-icon class="material-icons-outlined" matSuffix aria-hidden="true">schedule</mat-icon>
            <ngx-material-timepicker #startTime></ngx-material-timepicker>
        </mat-form-field>
    </div>

    <div class="cell">
        <span class="cell-label">{{ 'EndTime' | translate: {Default: "End time"} }}</span>
        <mat-form-field appearance="fill" subscriptSizing="dynamic">
            <input
                matInput
                [attr.aria-label]="label + ' end time'"
                placeholder="--:--"
                [ngxTimepicker]="endTime"
                [format]="24"
                formControlName="endTime"
            />
            <mat-icon class="material-icons-outlined" matSuffix aria-hidden="true">schedule</mat-icon>
            <ngx-material-timepicker #endTime></ngx-material-timepicker>
        </mat-form-field>
    </div>

    <div class="cell">
        <span class="cell-label">{{ 'BreakTimeHours' | translate: {Default: "Break (hrs)"} }}</span>
        <mat-form-field appearance="fill" subscriptSizing="dynamic">
            <input matInput type="number" [attr.aria-label]="label + ' break time'" min="0" step="0.01" formControlName="breakTime">
        </mat-form-field>
    </div>

    <div class="cell">
        <span class="cell-label">{{ 'UnpaidBreakTimeHours' | translate: {Default: "Unpaid break (hrs)"} }}</span>
        <mat-form-field appearance="fill" subscriptSizing="dynamic">
            <input matInput type="number" [attr.aria-label]="label + ' unpaid break time'" min="0" step="0.01" formControlName="unpaidBreakTime">
        </mat-form-field>
    </div>

    <div class="cell">
        <span class="cell-label">{{ 'WorkingHours' | translate: {Default: "Working hours"} }}</span>
        <span class="working-hours">{{ form.value.workingHours || '—' }}</span>
    </div>

    <button mat-icon-button type="button" class="icon-button clear-button"
        [disabled]="isDayOff"
        [matTooltip]="'ClearValues' | translate: {Default: 'Clear values'}"
        [attr.aria-label]="'ClearValues' | translate: {Default: 'Clear values'}"
        appPreventDoubleClick (throttledClick)="clearForm()">
        <mat-icon class="material-icons-outlined" aria-hidden="true">backspace</mat-icon>
    </button>
</form>
